import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteCart,
  fetchAllCarts,
} from "../../../../redux/reducer/cartReducer";
import DetailsCartTable from "./DetailsCartTable";
import LoadingSpinner from "../../../animation/LoadingSpinner";
import AddCartForm from "./AddCartForm";

const ReceivedCart = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [editingProducts, setEditingProducts] = useState(null);
  const dispatch = useDispatch();
  const { allCarts, loading, error } = useSelector((state) => state.carts);
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false);
  const [searchBox, setSearchBox] = useState("");

  const headers = [
    "ID",
    "Box. No",
    "img_Box",
    "Name",
    "Phone",
    "Status",
    "Area",
    // 'Notes',
    "Check Order",
    "Created At",
    "Tot_Cart",
    "Weight",
    "Tot_Pack_Fees",
    "ًWT_Aft_Pack",
    "Actions",
    "Prods",
  ];

  const refreshData = () => {
    dispatch(fetchAllCarts());
  };

  useEffect(() => {
    dispatch(fetchAllCarts());
  }, [dispatch]);

  const handleDelete = (cartId) => {
    if (window.confirm("Are you sure you want to delete this Cart?")) {
      dispatch(deleteCart(cartId))
        .unwrap()
        .then(() => {
          dispatch(fetchAllCarts());
        })
        .catch((error) => alert(error || "Failed to delete Cart."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllCarts());
  };

  const loadBrands = async () => {
    try {
      await dispatch(fetchAllCarts()).unwrap();
    } catch (error) {
      console.error("Failed to fetch the brands:", error);
    }
  };

  const receivedCartsBefore = allCarts.filter(
    (cart) => cart.status === "received" || cart.status === "outCart"
  );
  const receivedCarts = allCarts
    .filter((cart) => cart.status === "received" || cart.status === "outCart")
    .filter((cart) =>
      cart.referenceCode?.toLowerCase().includes(searchBox.toLowerCase())
    );
  if (loading && receivedCartsBefore.length === 0) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {/* Info */}
      <section className="flex justify-end gap-3 my-4">
        <div className="flex items-center gap-2">
          <div
            className={`relative w-4 h-4 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 bg-[#1FD224] border-gray-500`}
          ></div>
          <span className="text-xs font-medium text-black lg:text-sm">
            {t("To Be Packaged")}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className={`relative w-4 h-4 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 bg-[#FF8A1B] border-gray-500`}
          ></div>
          <span className="text-xs font-medium text-black lg:text-sm">
            {t("Shipping Only")}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <div
            className={`relative w-4 h-4 lg:w-5 lg:h-5 rounded flex items-center justify-center border-2 bg-white border-gray-500`}
          ></div>
          <span className="text-xs font-medium text-black lg:text-sm">
            {t("Waiting for the client")}
          </span>
        </div>
      </section>
      <Table
        title={t("Received Orders")}
        headers={headers}
        data={receivedCarts}
        addCart={true}
        setShowForm={setShowForm}
        searchBox={searchBox}
        setSearchBox={setSearchBox}
        renderRow={(cart, index) => (
          <DetailsCartTable
            key={cart._id || index}
            index={index + 1}
            details={{
              id: cart._id,
              number: index + 1,
              boxNumber: cart.referenceCode,
              Name: cart.user?.name,
              phone: cart.user?.phone,
              countryCode: cart.user?.countryCode,
              status: cart.status,
              note: cart.notesAdmin,
              history: cart.createdAt,
              products: cart.products,
              DShippingFees: cart.totalDShippingFees,
              markaShipFees: cart.markaShipFees,
              paymentStatus: cart.paymentStatus,
              timeLeft: cart.timeLeft,
              totalCartPrice: cart.totalCartPrice,
              totalCartPriceBeforeFees: cart.totalCartPriceBeforeFees,
              totalWeight: cart.totalWeight,
              totalPackingFees: cart.totalPackingFees,
              area: cart.area,
              isCheck: cart.isCheck,
              isOutCart: cart.isOutCart,
              isPacking: cart.isPacking,
              isReadyToPaid: cart.isReadyToPaid,
              totalWeightAfterPacking: cart.totalWeightAfterPacking,
              paymentPDF: cart.paymentPDF,
              img: cart.img,
            }}
            isEditing={editingOrder === cart._id}
            setEditingOrder={setEditingOrder}
            isProducts={editingProducts === cart._id}
            setEditingProducts={setEditingProducts}
            onDelete={() => handleDelete(cart._id)}
            onUpdate={handleUpdate}
            refreshData={refreshData}
            loading={loading}
          />
        )}
      />
      {showForm && (
        <AddCartForm
          onClose={() => {
            setShowForm(false);
            loadBrands();
          }}
        />
      )}
    </>
  );
};

export default ReceivedCart;
